import React from 'react'
import Product from "./Product";
import "./css/Home.css";
import {Link} from "react-router-dom";
import { SiteData } from "./SiteData";

function Home() {
  return (
    <div className="home">
      <div className='men'>
        <div className='men-cta'>
          <h1>Men Quality Clothes Selection</h1>
          <p>Here you will find quality men selection</p>
          <a href='/men-wears'><button>Men Clothes</button></a>
        </div>
      </div>
      <div className='women'>
        <div className='women-cta'>
        <h1>Women Quality Clothes Selection</h1>
        <p>Here you will find quality women selection</p>
        <a href='/women-wears'><button>Women Clothes</button></a>
        </div>
      </div>
    </div>
  )
}

export default Home